/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { Component } from 'react';
import { shape, string, object, bool, array, func } from 'prop-types';
import { connect } from 'react-redux';

import p from 'polyglot/polyglot';

import { updateCompany as updateCompanyAction } from 'actions/company';

import { makeCreateCompanyForm } from 'selectors/createCompanyForm';

import StepHeader from 'components/StepHeader/StepHeader';
import Form from 'components/Form/Form';

/**
 * This is the CreateCompany component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 */
export class CreateCompany extends Component {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    auth: shape({
      token: string.isRequired,
    }).isRequired,
    companyForm: shape({
      fieldsets: array.isRequired,
      validationMessages: object.isRequired,
      submitText: string.isRequired,
      sending: bool.isRequired,
      errors: object.isRequired,
    }).isRequired,
    updateCompany: func.isRequired,
  };

  updateCompany = data => {
    const { auth: { token }, updateCompany } = this.props;

    updateCompany(token, data);
  };

  /**
   * Render CreateCompany.
   *
   * @return {Object}
   */
  render() {
    const { companyForm } = this.props;

    return (
      <article>
        <StepHeader
          title={p.t('signup.create_company.title')}
          current={5}
          total={7}
        />
        <Form {...companyForm} onSubmit={this.updateCompany} />
      </article>
    );
  }
}

/**
 * Map state from redux store to props.
 */
const makeMapStateToProps = () => {
  const createCompanyForm = makeCreateCompanyForm();
  const mapStateToProps = (state, props) => {
    return {
      auth: state.auth,
      companyForm: createCompanyForm(state, props),
    };
  };
  return mapStateToProps;
};

export default connect(makeMapStateToProps, {
  updateCompany: updateCompanyAction,
})(CreateCompany);
